import { ITableColumn } from '@components/common/UTable/UTable';

import { OrganizationLevelType } from '@/shared/organizations/enums';

export const childrenOrgsTableConfig: ITableColumn[] = [
  {
    title: 'Организация',
    dataIndex: 'name',
  },
];

export const structuralTableConfig: ITableColumn[] = [
  {
    title: 'Структурное подразделение',
    dataIndex: 'name',
    render: (value: any, record: any) =>
      record?.level === OrganizationLevelType.STRUCTURAL_DIVISION ? value : '',
  },
  {
    title: 'Координаты',
    dataIndex: 'coordinates.coordinates',
    render: (value: any) => value?.join(', '),
  },
  {
    title: 'Радиус проверки геолокации (м)',
    dataIndex: 'geoRadiusM',
    render: (value: number | undefined, record: any) =>
      record?.level === OrganizationLevelType.STRUCTURAL_DIVISION ? (value ?? '') : '',
  },
  {
    title: 'Объект',
    dataIndex: 'facility',
    render: (value: any, record: any) =>
      record?.level === 'FACILITY' ? record?.name : '',
  },
];
